import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Guide from './pages/Guide';
import Dashboard from './pages/Dashboard';
import ModuleView from './pages/ModuleView';
import FinancePage from './pages/FinancePage';
import Settings from './pages/Settings';
import ChatBubble from './components/ChatBubble';
import LoginGate from './components/LoginGate';
import { InstallHint, UpdateBar } from './components/PwaPrompts';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 30,
      retry: 2,
    },
  },
});

export default function App({ swRegistration }) {
  return (
    <QueryClientProvider client={queryClient}>
      <LoginGate>
        <Router>
          <div className="min-h-screen bg-black text-white font-sans">
            <Routes>
              <Route path="/"           element={<Guide />}       />
              <Route path="/dashboard"  element={<Dashboard />}   />
              <Route path="/finance"    element={<FinancePage />} />
              <Route path="/settings"   element={<Settings />}    />
              <Route path="/module/08"  element={<Navigate to="/finance" replace />} />
              <Route path="/module/:id" element={<ModuleView />}  />
            </Routes>
            <ChatBubble excludePaths={['/finance']} />
            <InstallHint />
            <UpdateBar registration={swRegistration} />
          </div>
        </Router>
      </LoginGate>
    </QueryClientProvider>
  );
}
